import { Button } from "@/components/ui/button";
import { LoadingIcon } from "@/components/ui/loading-icon";

/**
 * Floating pill shown above the message list while older messages are
 * being fetched (load-more sentinel triggered). Pure render; no state
 * of its own.
 */
export function LoadingOlderPill() {
  return (
    <div className="absolute top-2 left-1/2 -translate-x-1/2 z-20">
      <Button
        variant="outline"
        size="sm"
        className="flex items-center gap-1.5 px-3 py-1.5 text-xs text-muted-foreground bg-background/80 backdrop-blur-sm rounded-full shadow-sm border border-border/50"
        disabled
      >
        <LoadingIcon size={14} className="text-muted-foreground" />
        Loading messages…
      </Button>
    </div>
  );
}
